import { FormOutlined } from '@ant-design/icons';
import { Col, Form, Input, Modal, Row } from 'antd';
import { useEffect } from 'react';
import type { FormLogParams, Log } from '@/features/log/types/Log';
import type { Dialog } from '@/std/dialog/types';
import { options } from '@/features/log/components/SelectAcao';

export function LogsDetalhesModal({ dialog }: { dialog: Dialog<Log> }) {
    const [formLog] = Form.useForm<FormLogParams>();

    useEffect(() => {
        formLog.resetFields();

        if (dialog.state.data) {
            formLog.setFieldsValue({
                log_data_insercao: dialog.state.data.log_data_insercao,
                log_descricao: dialog.state.data.log_descricao,
                log_tipo: options.find((o) => o.value === dialog.state.data?.log_tipo)?.label ?? '',
                log_usuario_nome: dialog.state.data.log_usuario_nome,
            });
        }
    }, [formLog, dialog.state]);

    return (
        <Modal
            destroyOnHidden
            footer={null}
            onCancel={() => dialog.actions.close()}
            open={dialog.state.open}
            title={
                <>
                    <FormOutlined /> Detalhes do log
                </>
            }
            width={800}
        >
            <Form form={formLog} layout='vertical'>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label='Data e Hora' name='log_data_insercao'>
                            <Input disabled />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label='Ação' name='log_tipo'>
                            <Input disabled />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item label='Usuário' name='log_usuario_nome'>
                            <Input disabled />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item label='Descrição do log' name='log_descricao'>
                            <Input.TextArea autoSize={{ minRows: 4 }} disabled />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
